import React from 'react';
import { asset } from '@/lib/api';
import { Reveal } from '@/components/Reveal';
import { motion } from 'framer-motion';
import { EASE } from '@/lib/motion';

export const Intro = ({ about }) => {
  const sec = about?.introSection;
  if (!sec) return null;
  return (
    <section className='bg-[#F6F5F1]'>
      <div className='container-x py-20 lg:py-28'>
        <div className='grid gap-12 lg:grid-cols-12 lg:gap-16'>
          <div className='lg:col-span-7'>
            <Reveal>
              <div className='flex items-center gap-3'>
                <span className='h-px w-8 bg-[#B88A3B]' />
                <span className='eyebrow text-[#075B61]'>{sec.eyebrow}</span>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className='mt-5 font-head text-4xl font-semibold leading-[1.06] tracking-[-0.02em] text-[#20272A] sm:text-5xl lg:text-[3.4rem]'>
                {sec.headline}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className='mt-7 max-w-xl text-lg leading-relaxed text-[#20272A]/70'>{sec.text}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className='mt-5 max-w-xl leading-relaxed text-[#20272A]/60'>{about?.intro}</p>
            </Reveal>
          </div>
          <div className='lg:col-span-5'>
            <motion.div
              className='relative overflow-hidden rounded-2xl'
              initial={{ opacity: 0, scale: 1.08 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 1.1, ease: EASE }}
            >
              <img src={asset('/media/img/quarry-dusk.jpg')} alt='Excavation and earthworks at scale' className='h-[420px] w-full object-cover lg:h-[520px]' />
              <div className='absolute inset-0' style={{ background: 'linear-gradient(180deg, transparent 55%, rgba(32,39,42,0.55) 100%)' }} />
              <div className='absolute bottom-5 left-5 border-l border-[#B88A3B] pl-4'>
                <div className='font-mono-num text-sm text-[#F6F5F1]'>Since 1970</div>
                <div className='text-xs text-[#F6F5F1]/70'>Handwork & experience</div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
